<template>
    <div class="calendar-select-popup">
        <form-row label="Person"  required>
            <form-select :inherit-width="false" v-model="calendarId" :options="calendarOptions">
                <template #placeholder>[Besitzer wählen]</template>
            </form-select>
        </form-row>
    </div>
</template>

<script setup lang="ts">
    import type AppPopup from '@/components/AppPopup.vue';
    import {usePortuna} from '@/composables/portuna';
    import FormRow from '@/components/form/FormRow.vue';
    import FormSelect from '@/components/form/FormSelect.vue';
    import {popupDefaultCancelButton} from '@/library/popup';
    import router from '@/router';
    import {ref, computed, watch} from 'vue';

    const portuna = usePortuna();

    const props = (
        defineProps<{
            calendarOptions: SelectOption[],
            type: string,
            resource: string,
        }>()
    );

    const emit = defineEmits<{
        setButtons: [buttons: PopupButton[]];
    }>();

    const calendarId      = ref<number>(0);

    const buttons = computed((): PopupButton[] =>
    {
        return [
            Object.assign(popupDefaultCancelButton),
            Object.assign(
                {
                    type: 'success',
                    title: props.type === 'add' ? 'Termin erstellen' : 'Termin finden',
                    icon: 'add',
                    disabled: !calendarId.value,
                    cmd: (popup: AppPopup) =>
                    {
                        if (props.type === 'add')
                        {
                            router.push({
                                name: props.resource! + '-entry-add',
                                params: {calendar: calendarId.value},
                            }).then();
                        }
                        else
                        {
                            router.push({
                                name: props.resource! + '-entry-find',
                                params: {calendar: calendarId.value},
                            }).then();
                        }

                        popup.close();
                    },
                },
            ),
        ];
    });

    const watchCalendars = () =>
    {
        emit('setButtons', buttons.value);
    };

    emit('setButtons', buttons.value);

    watch(calendarId, watchCalendars);

    defineExpose(Object.assign({}, portuna));
</script>